// DS: i7.14
import React from 'react';
import IconWrap from '../../IconWrap';
const Italic = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9 6v.001a1 1 0 001 1h1.713l-1.592 10H8.999A1 1 0 009 19H14a1 1 0 000-1.999h-1.853l1.591-10H15a1 1 0 001-1V6a1 1 0 00-1-1h-5a1 1 0 00-1 1z"
    })));
};
Italic.displayName = 'Italic';
export default Italic;
